
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Injectable, Injector, Input, OnInit, ViewChild, ViewRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { NzFormatEmitEvent, NzTreeNodeOptions } from 'ng-zorro-antd/tree';
import { Observable, Subject, Subscription } from 'rxjs';
import { findIndex } from 'rxjs/operators';
import { action } from 'src/app/interfaces/action';
import { CardView } from 'src/app/interfaces/cardview';
import { ChildrenForm } from 'src/app/interfaces/children';
import { columnsDef } from 'src/app/interfaces/columnsDef';
import { Filter } from 'src/app/interfaces/filter';
import { FormConfig } from 'src/app/interfaces/formconfig';
import { DialogService } from 'src/app/services/dialog.service';
import { HTTPService } from 'src/app/services/http.service';
import { PermissionServices } from 'src/app/services/permission.services';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { UserConfigServices } from 'src/app/services/user-config.services';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { SimpleFilterViewComponent } from '../simple-filter-view/simple-filter-view.component';
import { PromptFilterViewComponent } from '../prompt-filter-view/prompt-filter-view.component';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { ResizeEvent } from 'angular-resizable-element';
import { MaskEditField } from 'src/app/interfaces/user-authentication';
import { HttpErrorResponse } from '@angular/common/http';
import { REGISTRY } from 'src/app/interfaces/registry-services';
import { CustomActionParametersComponent } from '../simple-datagrid/custom-action-parameters/custom-action-parameters.component';
import { DynamicFormsService } from 'src/app/services/dynamic-forms.service';
import { ItensPermission } from 'src/app/interfaces/RolePermission';
import { flowData } from 'src/app/interfaces/flowData';
import { FlowModalComponent } from '../flow-action/flowaction.component';
import { ThemeService } from 'src/app/services/theme.service';
import { LanguageServices } from 'src/app/services/LanguageServices';

@Component({
    selector: 'simple-datatree',
    templateUrl: './simple-datatree.component.html',
    styleUrls: ['./simple-datatree.component.scss'],
    standalone: false
})
export class SimpleDatatreeComponent implements OnInit, AfterViewInit {

  selectedRows = [];
  actionList:action[] = [];
  showEdit = false;
  showIcon = true;
  filterSelect = new UntypedFormControl();
  filter:Filter[] = [];
  tableInformation:columnsDef[];
  @Input() entityName:string = 'Mktptraycorpcategory';
  formConfig:FormConfig[] = [];
  showAction = false;
  /** controla a abertura do dropdown do filtro (nz-select) */
  filterPanelOpen = false;
  compareFilter = (a: Filter, b: Filter): boolean => a && b && a.name === b.name;
  /** spinner NG-ZORRO (substitui o ngx-spinner nomeado) */
  treeLoading = false;
  @Input()parentRow:CardView = {};
  @Input()parentCondition:string;
  @Input() events: Observable<void>;
  row:Object;
  formViewColumns = 3;
  userConfig:object;
  formGroup:UntypedFormGroup;
  evento:string;
  readonly alterando:string = "editando";
  readonly inserindo:string = "inserindo";
  readonly excluindo:string = "inserindo";
  readonly acao:string = "acao";
  $$REFERENCES:ChildrenForm[];
  @Input()condition:string;
  editing:Subject<Boolean> = new Subject<Boolean>();
  editingRowIndex: number = -1;
  loading:boolean = false;
  filtrando: boolean = false;
  totalLines: number;
  /** nós da árvore NG-ZORRO (substitui o TreeviewItem[] do ngx-treeview) */
  nodes: NzTreeNodeOptions[] = [];
  checkedKeys: string[] = [];
  searchValue = '';
  expandAll = false;
  allChecked = false;
  rows:Object[] = [];
  codeField:string = null;
  nameField:string = null;
  maskField:string = null;
  parentField:string = null;
  grauField:string ='GRAU';
  canEdit:boolean;
  canDelete:boolean;
  canInsert:boolean;
  canConfig:boolean=false;
  fatherCondition="";
  leftDiv = 50;
  rightDiv = 50;
  codecompany;
  public style: object = {};
  public theBoundCallback: Function;
  sub:Subscription;
  sub2:Subscription;
  sub3:Subscription;
  sub4:Subscription;
  sub5:Subscription;
  sub6:Subscription;
  sub7:Subscription;
  sub20:Subscription;
  lastFilter:Object;
  companyList:Object[];
  showGetFrom:boolean = false;
  codeContract;
  permission: ItensPermission;
  showDel:boolean = false;
  disabled:boolean = false;

  constructor(private dialogServices:DialogService, private ucs:UserConfigServices, public uas:UserAuthenticationServices,
    private http:HTTPService,private cd:ChangeDetectorRef, private fb:UntypedFormBuilder,
    private ap:PermissionServices,private snackBar:SnackbarService,
    private injector: Injector,public ThemeService:ThemeService, private dynaServices:DynamicFormsService, private translate:LanguageServices) { }
  
  
  ngAfterViewInit(): void {
    
  }

  /** mantém apenas o nó informado marcado (ou desmarca tudo se null) */
  deselectAll(keep, children?: any){
      this.checkedKeys = keep != null ? [String(keep)] : [];
      this.allChecked = false;
  }

  /** clique no título do nó: abre o registro no editform (substitui o parse de DOM do ngx-treeview) */
  onNodeClick(event: NzFormatEmitEvent){
      const key = event.node != null ? event.node.key : null;
      if ( key == null || this.tableInformation == null ){
        return;
      }

      this.showEdit = false;
      this.row = this.rows.find(findData=>findData[this.codeField] == key);

      if ( ObjectUtil.isNotEmpty(this.row)){

        const mouseEvent = event.event as MouseEvent;
        if ( mouseEvent == null || !mouseEvent.ctrlKey ){
          this.deselectAll(key);
        }

        this.formGroup = this.fb.group({});
        this.evento = this.alterando;
        this.editing.next(true);

        this.editingRowIndex = this.rows.findIndex(data=>data[this.codeField] == key);
        setTimeout(()=>{
          this.showEdit = true;
          this.cd.markForCheck();
        },100);
      }
  }

  onCheckChange(event: NzFormatEmitEvent){
      this.checkedKeys = (event.keys || []).map(k=>String(k));
      this.allChecked = false;
  }

  checkAll(checked: boolean){
      this.allChecked = checked === true;
      this.checkedKeys = this.allChecked ? this.collectAllKeys(this.nodes) : [];
  }

  private collectAllKeys(children: NzTreeNodeOptions[]): string[] {
      let keys: string[] = [];
      (children || []).forEach(node=>{
          keys.push(String(node.key));
          if ( node.children != null && node.children.length > 0 ){
            keys = keys.concat(this.collectAllKeys(node.children));
          }
      });
      return keys;
  }

  selectionProcess(x){
        let dataOb = x['Mktpcontractpref'][0];
        
        if ( !ObjectUtil.isNotEmpty(dataOb)){
          this.treeLoading = false;
          throw new Error("Não existe configuração para entidade na empresa selecionada.");
        }
        this.codeContract = dataOb['CODECONTRACT'];     
        let data = JSON.parse(dataOb['TEXT']);
        this.codeField = data['codeField'];
        this.parentField = data['parentField'];
        this.nameField = data['nameField'];
        this.maskField = data['maskField'];
        if ( ObjectUtil.isNotEmpty(data['grauField'])){
          this.grauField = data['grauField'];
        }
        
        let maskEditField:MaskEditField =  this.uas.user.maskEditField.find(data=> data.entityName == this.entityName && data.columnName == this.codeField);

        if ( maskEditField != null ){
          maskEditField.mask = this.maskField;
        }else{
          this.uas.user.maskEditField.push({mask:this.maskField, entityName: this.entityName, columnName: this.codeField, padding: true});
        }
        
        this.apply();
  }

  selecting(event){
    this.treeLoading = true;
    this.codecompany = event;
    
    let ob= {
      "entityName":'Mktpcontractpref',
      "showPresentation":true,
      "showRelationshipData":false,
      "showRelationship":true,
      "condition":"this.codecompany="+ this.codecompany + " and this.name='HIERARCHY_"+this.entityName+"'"
    }
    
    this.sub = this.http.post(ob,"JsonBrokerServices/find",true).subscribe(x=>{
        this.selectionProcess(x);
    });
    
  }


  dragEnd(type:string,event){
    
      this.leftDiv = event.sizes[0];
      this.rightDiv = event.sizes[1];
      this.saveUserConfig();
  }

  onResizeEnd(event: ResizeEvent): void {
    this.style = {
      position: 'fixed',
      left: `${event.rectangle.left}px`,
      top: `${event.rectangle.top}px`,
      width: `${event.rectangle.width}px`,
      height: `${event.rectangle.height}px`
    };
  }

  ngOnInit(): void {

    this.theBoundCallback = this.afterFunction.bind(this);

    this.permission = this.ap.checkPermission(this.entityName);
    this.canInsert = this.permission.canInsert;
    this.canEdit = this.permission.canEdit;
    this.canDelete = this.permission.canDelete;
    this.canConfig = this.permission.canConfig;
    this.fatherCondition = this.condition;

    
    this.getAllData();
    this.row = {};
      
    this.sub7 = this.ucs.loadActions(this.entityName).subscribe(responseAction=>{
      this.actionList = responseAction['Mktpdicaction'];
      
      this.actionList = this.actionList.filter(data=> this.ap.checkActionPermission(data.IDACTION) )
      
      if ( this.actionList.length > 0 ){
        this.showAction = true;
      }
      this.loading = false;
      this.cd.detectChanges();
    });

    this.sub20 = this.ucs.loadGetFromAction(this.entityName,this.uas.user).subscribe(responseAction=>{
      let data:Object[] = responseAction['Mktpcontractpref'];
      if ( data != null && data.length > 0 ){
        this.showGetFrom = true;
      }else{
        this.showGetFrom = false;
      }
      
      this.loading = false;
      this.cd.detectChanges();
    });

  }


  getAllData(){

    this.loading = true;
    this.treeLoading = true;
    this.sub2 = this.ucs.loadUserConfig(this.uas.user.iduser,this.entityName).subscribe(response=>{

      this.userConfig = {};
      if ( ObjectUtil.isNotEmpty(response['Mktpusercfg'])){
        if ( ObjectUtil.isNotEmpty(response['Mktpusercfg'][0])){
          
          if ( ObjectUtil.isNotEmpty( response['Mktpusercfg'][0]['FILTER'])){
              this.filter = JSON.parse( response['Mktpusercfg'][0]['FILTER']);
          }

          if ( ObjectUtil.isNotEmpty( response['Mktpusercfg'][0]['CONFIG'])){
            
            if ( ObjectUtil.isNotEmpty( response['Mktpusercfg'][0]['CONFIG'])){

              this.userConfig = JSON.parse( response['Mktpusercfg'][0]['CONFIG']);
              
              if ( Object.keys(this.userConfig).findIndex(ind=>ind=='formviewcolumns') > -1){
                  this.formViewColumns = this.userConfig['formviewcolumns'];
              } 

              if ( Object.keys(this.userConfig).findIndex(ind=>ind=='leftdiv') > -1){
                this.leftDiv = this.userConfig['leftdiv'];
              } 

              
              if ( Object.keys(this.userConfig).findIndex(ind=>ind=='rightdiv') > -1){
                this.rightDiv = this.userConfig['rightdiv'];
              } 

              if ( Object.keys(this.userConfig).findIndex(ind=>ind=='config')  > -1  ){
                this.formConfig = this.userConfig['config'];
              }
            }
          }
        }
      } 

      this.companyList = this.uas.user.companylist;
      
      if ( this.uas.user.companylist.length == 1 ){
        this.codecompany = this.uas.user.codecompany;

        let ob= {
          "entityName":'Mktpcontractpref',
          "showPresentation":true,
          "showRelationshipData":false,
          "showRelationship":true,
          "condition":"this.codecompany="+ this.codecompany + " and this.name='HIERARCHY_"+this.entityName+"'"
        }

        this.sub4 = this.http.post(ob,"JsonBrokerServices/find",true).subscribe(x=>{
          this.selectionProcess(x);
        });
      }else{
        this.treeLoading = false;
      }
    });
  }


  ngOnDestroy(){
      if ( this.sub!= null ){this.sub.unsubscribe();}
      if ( this.sub2!= null ){this.sub2.unsubscribe();}
      if ( this.sub3!= null ){this.sub3.unsubscribe();}
      if ( this.sub4!= null ){this.sub4.unsubscribe();}
      if ( this.sub5!= null ){this.sub5.unsubscribe();}
      if ( this.sub6!= null ){this.sub6.unsubscribe();}
      if ( this.sub7!= null ){this.sub7.unsubscribe();}
      if ( this.sub20!= null ){this.sub20.unsubscribe();}
  }


  openFilter(){

    let data= {
      filters: this.filter,
      columns: this.tableInformation
    }

    this.dialogServices.openGenericDialog(SimpleFilterViewComponent,data,(data)=>{
        this.saveUserConfig();
    },()=>{
        this.saveUserConfig();
    });
  }

  saveUserConfig(){
      
    let jsonDec:Object ={
      "entityName":"Mktpdic",
      "condition":`instancename='${this.entityName}'`
    };

    let userConfig = {
        formViewColumns: this.formViewColumns,
        config: this.formConfig,
        leftdiv: this.leftDiv,
        rightdiv: this.rightDiv
    }

    Object.keys(this.userConfig).forEach(key=>{
      if ( key == 'formViewColumns' || key =='config' || key == 'configgrid'){
        userConfig[key] = this.userConfig[key];
      }
    })
    
    this.ucs.saveUserCfg(jsonDec,this.uas.user.iduser,this.filter,userConfig).then(me=>{

    }, error=>{
      throw error;
    });
  }


  savingForm(data1){
    
    if ( this.evento == "editando"){
    
        let ob:Object = {};  
        this.tableInformation.filter(x=>{return x.ISPK === 1}).forEach(y=>{
              ob['this.'+y.COLUMNNAME] = this.formGroup.get(y.COLUMNNAME).value; //jdbc    
              //ob[y.COLUMNNAME] = this.formGroup.get(y.COLUMNNAME).value;    
          
        });
        
        this.condition = ObjectUtil.transformConditionToString(ob);
        
        this.refreshData();
        this.showEdit = false;
        this.row ={};
        this.deselectAll(null);
      }else{
          
          if ( this.evento == "inserindo" ){
              this.editing.next(false);
              
              let ob:Object = {};  
              if ( ObjectUtil.isNotEmpty(this.parentRow )){
                this.parentRow.table_information.filter(x=>{return x.ISPK === 1}).forEach(y=>{
                  ob[y.COLUMNNAME] = this.parentRow.linha[y.COLUMNNAME];    
              
                });
              }
              this.tableInformation.filter(x=>{return x.ISPK === 1}).forEach(y=>{
                  if ( !ObjectUtil.isNotEmpty(ob[y.COLUMNNAME])){
                    ob[y.COLUMNNAME] = this.formGroup.get(y.COLUMNNAME).value;
                  }
              });
              
              this.refreshData();
              this.showEdit = false;
              this.row ={};
          
          }
      }
  }


  refreshData( callbackFunction?:()=>{}){
    
    this.treeLoading = true;
    this.loading = true;
    
    let ob= {
      "entityName":this.entityName,
      "showPresentation":true,
      "showRelationshipData":false,
      "showRelationship":true,
      "rows":100000
    }
    
    this.condition = this.condition + " and this.codecompany="+this.codecompany;


    if ( ObjectUtil.isNotEmpty(this.condition) ){
        ob["condition"] =  this.condition ;
    }
    

    
    let index = -1;

    if ( this.evento == this.alterando || this.evento == this.acao || this.evento == this.inserindo ){
          index = this.editingRowIndex;
    }

    
    if ( this.filtrando ){
        this.filtrando = false;
    }
    
    this.sub5 = this.http.post(ob,"JsonBrokerServices/find",true).subscribe(x=>{
      
      let tableInformation:columnsDef[] = x['table_information'];
      this.totalLines = x['totalLines'];
      let $$REFERENCES:ChildrenForm[] = x["$$REFERENCES"];
      
      

      if ( this.evento == this.alterando || this.evento == this.acao ){
        this.updateHierarchy(index,x[this.entityName][0]);
        this.condition = this.parentCondition;
        this.evento = null;
      }else{
        if ( this.evento == this.excluindo){
          this.nodes = [];
          this.rows = [];  
          this.evento = null;
          this.rows = x[this.entityName];
          this.generateHierarchy(tableInformation,x[this.entityName]);
        }else{
          this.nodes = [];
          this.rows = [];
          this.rows = x[this.entityName];
          this.evento = null;
          this.generateHierarchy(tableInformation,x[this.entityName]);
        }
        
      }
      
      this.loading = false;
      this.treeLoading = false;
      setTimeout(() => {
        if (this.cd !== null && this.cd !== undefined &&
          !(this.cd as ViewRef).destroyed) {
            this.cd.detectChanges();
        }
        }, 250);


      if ( callbackFunction != null ){
        callbackFunction.call(this)
      }
      
      if ( this.formConfig.length > 0 ){
        this.formConfig.forEach((config:FormConfig)=>{
            let col:columnsDef = tableInformation.find(column=>column.COLUMNNAME === config.name)
            if ( col != null ){
              col.cols = config.colspan == undefined? 1 : config.colspan;
              col.rows = config.rowspan == undefined? 1 : config.rowspan;
              col.x = config.x;
              col.y = config.y;
              col.visible = config.visible == undefined ? true : config.visible;
              col.tab = config.tab == undefined ? "Geral" : config.tab;
            }
        });
      }

      this.tableInformation = tableInformation;
      this.$$REFERENCES = $$REFERENCES;
      this.loading = false;
      this.treeLoading = false;
    },error=>{
      this.treeLoading = false;
      throw error;
    },()=>{
      this.treeLoading = false;
    })
  }

  
  transformcondition():string{
    
    let condition:string = "";

    const selectedFilters: Filter[] = (this.filterSelect.value as Filter[]) || [];

    if ( selectedFilters.length > 0 ){
      let i:number = 0;
      selectedFilters.forEach(value=>{
          if ( i == 0){
            condition = condition + " " + value.expression;
          }else{
            condition = condition + " AND " + value.expression;
          }
          i++;
      });
    }else{
      condition = " 0=0 ";
    }

    return condition;
  }


  
  apply(type:string=null){
      
      if ( this.codecompany == null){
        throw new Error("Selecionar uma empresa para atualizar a lista.");
      }

      if ( this.maskField == null ){
          throw new Error("Não existe configuração de máscara na empresa selecionada.");
      }

      
      if ( this.codeField == null ){
        throw new Error("Não existe configuração de código na empresa selecionada.");
      } 

      if ( this.parentField == null ){
        throw new Error("Não existe configuração de código pai na empresa selecionada.");
      } 

      if ( this.nameField == null ){
        throw new Error("Não existe configuração de nome na empresa selecionada.");
      } 
      if ( type == 'total'){
        this.evento = null;
        this.selectedRows = [];
        this.showEdit = false;
        this.editing.next(false);
      }

      this.condition = this.fatherCondition + " AND " +this.transformcondition();
      this.filtrando = true;
    
      this.filtrando = true;
      if ( this.condition != null ){
        if ( this.condition.indexOf("{") > -1 && this.condition.indexOf("}") > -1 ){
    
          this.dialogServices.openGenericDialog(PromptFilterViewComponent,{data:this.condition,lastFilter:this.lastFilter},(data)=>{
              this.condition = JSON.parse(data).expressao;
              this.lastFilter = JSON.parse(data).group;
              this.refreshData();
          },()=>{
            this.treeLoading = false;
          })
        }else{
          this.refreshData();
        }
      }else{
        this.refreshData();
      }

      
  }

  editFilter(event:Event,item:Filter){
    event.stopPropagation();
    event.preventDefault();

    let data= {
      filters: this.filter,
      columns: this.tableInformation,
      editing: item
    }

    this.dialogServices.openGenericDialog(SimpleFilterViewComponent,data,(data)=>{

        this.saveUserConfig();
        this.filterPanelOpen = false;
    },()=>{
    });

  }

  removeFilter(event:Event,item:Filter){
    event.stopPropagation();
    event.preventDefault();


    this.dialogServices.openNewDialog(this.translate.instant("datatree.deleteFilterConfirm"),data=>{
      this.excluirFiltro(item);
      this.filterPanelOpen = false;
    });
  }

  excluirFiltro(data:Filter){
      let index = this.filter.findIndex(c=>c.name == data.name);
      this.filter.splice(index,1);
      this.saveUserConfig();
  }
  
  updateHierarchy(index: number, row: Object) {

      this.rows[index] = row;

      let code = this.doMask(String(row[this.codeField]),this.maskField,true);
      let value = row[this.codeField];
      let name = row[this.nameField];

      let item:NzTreeNodeOptions = this.findParent(value,this.nodes);

      if ( item != null ){
        item.title = code + " - " +name;
      }
      // nova referência para o nz-tree re-renderizar
      this.nodes = [...this.nodes];
  }

  generateHierarchy(tableInformation: columnsDef[], rows:Object[]) {

        this.nodes = [];
        this.checkedKeys = [];
        this.allChecked = false;

        rows.sort((a:Object,b:Object)=>{

          if (a[this.codeField] < b[this.codeField]  ) return -1;
            if (a[this.codeField] > b[this.codeField]  ) return 1;
            return 0;
        });

        if ( rows.length > 0 ){

            rows.forEach ( data=>{
                let code = this.doMask(data[this.codeField].toString(),this.maskField,true);
                let value = data[this.codeField];
                let name = data[this.nameField];
                let pai = data[this.parentField];

                let node: NzTreeNodeOptions = { title: code + " - " + name, key: String(value), children: [], isLeaf: true };

                let item:NzTreeNodeOptions = this.findParent(pai, this.nodes);

                if ( item == null){
                  this.nodes.push(node);
                }else{
                    item.isLeaf = false;
                    if ( item.children == null){
                      item.children = [node];
                    }else{
                      item.children.push(node);
                    }
                }
            })
        }

        this.nodes = [...this.nodes];
  }

  findParent(value, children:NzTreeNodeOptions[]):NzTreeNodeOptions{

      var item;

      for ( var i:number = 0; i < children.length; i++ ){
          if ( children[i].key == String(value) ){
            return children[i];
          }else{
              if (children[i].children && children[i].children.length) {
                item = this.findParent(value,children[i].children);
              }
              if ( item ){
                return item;
              }
          }
      }

      return item;
  }

  doMask(dataValue:string, maskExpression:string, padding:boolean){
    
    if ( padding ){
      let m = maskExpression;
      m = m.replace(/\./g,'');
      let k = dataValue.toString().padStart(m.length,'0');
      return this.applyMask(k, maskExpression);
    }else{
      return this.applyMask(dataValue, maskExpression);
    }
    
  }

  private applyMask(value: string, mask: string): string {
    if (!value || !mask) return value || '';
    
    let result = '';
    let valueIndex = 0;
    
    for (let i = 0; i < mask.length && valueIndex < value.length; i++) {
      if (mask[i] === '0' || mask[i] === '9') {
        result += value[valueIndex];
        valueIndex++;
      } else {
        result += mask[i];
        if (value[valueIndex] === mask[i]) {
          valueIndex++;
        }
      }
    }
    
    return result;
  }

  onSelectedChange(downlineItems): void {
      
  }

  onFilterChange(event){
      
  }

  adicionarLine($event){

    this.showEdit = false;
    this.editing.next(true);
    this.formGroup = this.fb.group({})
    this.row = {};
    this.evento = this.inserindo;
    this.deselectAll(null)

    setTimeout(()=>{
      this.showEdit = true;
      this.cd.markForCheck();
    },100);
  }


  getSelectedLines(children?: any){
    this.selectedRows = this.selectedRows.concat(this.checkedKeys);
  }


  removeLine($event){
    this.selectedRows = [];
    this.getSelectedLines()

    let cnt =  this.selectedRows.length;
    this.evento = this.excluindo;
    if ( cnt == 0 ){
      this.snackBar.showError(this.translate.instant("datatree.noRowSelected"));
       return;
    }
    
    try{
      
     
            this.dialogServices.openNewDialog(this.translate.instant("datatree.deleteConfirm"),async ()=>{

              
              for (const rowNode of this.selectedRows) {

                let x = this.rows.find(data=>data[this.codeField] == rowNode);
                
                let ob:Object = {};  
                this.tableInformation.filter(x=>{return x.ISPK === 1}).forEach(y=>{
                    ob[y.COLUMNNAME] = x[y.COLUMNNAME];
                });
                
                
                let remove:Object = {}; 
                let condition:string = ObjectUtil.transformConditionToString(ob);
                remove["entityName"] = this.entityName;
                remove["condition"] = condition;
                
                await new Promise((resolve,reject)=>{
                  this.sub6 = this.http.post(remove,"JsonBrokerServices/remove",false).subscribe(x=>{
                        this.snackBar.showSuccess(this.translate.instant("datatree.deleteSuccess"));
                        resolve(true);
                    },error=>{
                      resolve(true);
                      throw error;
                    }
                  )
                });
                
              }
              
                this.showEdit = false;
                this.editing.next(false);
                this.apply();
            }, 
            ()=>{
              
            
          });

    }catch (Exception ){
      throw Exception;
    } 
  }

  afterFunction(formGroup:UntypedFormGroup){

    let value:string = formGroup.get(this.codeField).value as string;

    if ( value == null){
      return;
    }

    let maskedValue:string = this.doMask(value,this.maskField,true)+".";
    
    let regex = new RegExp(/\./g);
    var match;
    
    let digits = String(maskedValue).replace(/\./g,'').length;
    let i = 0;
    let lastIndex = -1;
    let index:{value:string, parent:string, grau:number}[] = []
    
    let parentValue =  '-'.padEnd(digits, '9');
    
    while ((match = regex.exec(maskedValue))) {
      //parentValue = 0;
      let part: String = match.input.substr(lastIndex+1, match.index - lastIndex -1);
      let parentPart = match.input.substr(0,match.index);
      let parentPadPart = parentPart.replace(/\./g,'').padEnd(digits,0)
      
      if ( index.findIndex(value=>value.value == parentPadPart ) == -1){
        index.push({value:parentPadPart, parent:parentValue, grau:i+1})
      }

      i++;
      parentValue = parentPadPart;
      lastIndex = match.index;
    }
    
    let dataValue = index.find(x=>x.value == value);
    if ( dataValue!= null ){
      formGroup.get(this.parentField).setValue(dataValue.parent);
      formGroup.get(this.grauField).setValue(dataValue.grau);
    }
    
  }

  callCustomAction(action:action){

    if ( action.TYPE === "P" || action.TYPE==="J" || action.TYPE==="F"){

      if ( action.PARAMETERS != null && action.PARAMETERS.length > 0 ){
          this.dialogServices.openGenericDialog(CustomActionParametersComponent, action.PARAMETERS,(data)=>{
    
            this.executeCustomAction(action,data);
          })
      }else{
        this.executeCustomAction(action,null);
      }
    }else{
      if ( action.TYPE == "A"){

        let serviceName = action.EXPRESSION.split(".")[0];
        let methodName = action.EXPRESSION.split(".")[1];
        let parameter = action.PARAMETERS;
        const component = REGISTRY.get(serviceName);
        const service = this.injector.get<any>(component);

        if ( parameter != null && parameter.length > 0) {
          service[methodName]([this.formGroup.getRawValue()],parameter);
        }else{
          service[methodName]([this.formGroup.getRawValue()]);
        }
        
      }else if(action.TYPE == "C"){
        this.selectedRows = [];
        this.getSelectedLines()

        let cnt =  this.selectedRows.length;
        this.evento = this.acao;
        if ( cnt == 0 ){
          this.snackBar.showError(this.translate.instant("datatree.noRowSelectedFlow"));
          return;
        }
        if ( cnt > 1 ){
          this.snackBar.showError(this.translate.instant("datatree.noMultipleActions"));
          return;
        }

        let rows:Object[] = [];
        for (const rowNode of this.selectedRows) {
           rows.push(this.rows.find(data=>data[this.codeField] == rowNode));
        }
        

        if (action.PARAMETERS != null && action.PARAMETERS.length > 0) {
          this.dialogServices.openGenericDialog(
            CustomActionParametersComponent,
            action.PARAMETERS,
            (data) => {
              //this.executeCustomAction(action, data);
              openFlowData(data,rows, this);
            }
         );
        }else{
          openFlowData(null, rows, this);
  
        }        
      }
    }

    function openFlowData(parameters, rows, self) {
      
      let flowData: flowData = {
        selected: rows,
        action: action,
        function: null,
        parameters: parameters
      };



      self.dialogServices.openGenericDialog(
        FlowModalComponent,
        flowData,
        (data) => {
        },
        ()=>{},
        "80vh",
        "80vw",
        true,
        null,
        "S",
        "30px"
      );
    }
}


executeCustomAction(action:action, parameters:string, retry:boolean = false){

  this.http.executeBackEndAction(this.entityName, action, [this.formGroup.getRawValue()], parameters, retry ).subscribe(sucesso=>{
     let mensagens:string[] = sucesso['mensagens'];
     
     let mensagemFinal:string = "";
     if ( ObjectUtil.isNotEmpty(mensagens)){
        mensagens.forEach(mensagem=>{
          mensagemFinal = mensagemFinal + mensagem + "\n\r"
       })

       this.snackBar.showSuccess(mensagemFinal);
     }else{
      this.snackBar.showSuccess(this.translate.instant("datatree.actionSuccess"));
     }

     this.refreshData();
  },exception=>{

    if ( exception instanceof HttpErrorResponse ){

      if ( ObjectUtil.isNotEmpty(exception.error) && ObjectUtil.isNotEmpty(exception.error.message)){

        if ( (exception.error.message as String).indexOf("__CHOOSE__N__S__")>-1){
            let title = exception.error.message.split("__")[2];
            this.dialogServices.openNewDialog(title,(data)=>{
              this.executeCustomAction(action,parameters, true);
            },(data)=>{
                this.snackBar.showInformation(this.translate.instant("datatree.processCancelled"));
            });
        }else{
          throw exception;    
        }

      }else{
        throw exception;
      }
  
    }else{
      throw exception;
    }
    
  });

  }

  getFrom(event){
    
    if ( this.parentRow.linha == null ){
      this.parentRow.linha = {CODECOMPANY:this.codecompany, CODECONTRACT: this.codeContract}
    }

    this.dynaServices.getFrom(this.parentRow.linha, this.entityName,null, this.selectedRows[0]).then(d=>{
      this.apply();
    }).catch(reason=>{
        throw reason;
    });
    
  }

}
